import { PostRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { CreateCourierDto } from "./useCreateCourier"
import { ECourierStatusType } from "../../Enum/ECourierStatusType"
import { ERequestType } from "../../Enum/ERequestType"

export const useSaveCourier = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleTryCourierCreateAccountAsync = async (createCourierDto: CreateCourierDto, onSuccess: any) => {
    try {
      enableLoad()

      var response = await PostRequest<boolean>(API_ROUTES.DELIVERY.COURIER_REGISTER, createCourierDto)

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleTryCourierLinkAsync = async (mail: String, onSuccess: any) => {
    try {
      enableLoad()

      var response = await PostRequest<boolean>(API_ROUTES.DELIVERY.COURIER_LINK, { email: mail })

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleTryUnlinkCourierLinkAsync = async (courierId: String, onSuccess: any) => {
    try {
      enableLoad()

      var response = await PostRequest<boolean>(API_ROUTES.DELIVERY.COURIER_UNLINK, { courierId: courierId })

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleUpdateStatusAsync = async (
    courierStatusType: ECourierStatusType,
    latitude?: number,
    longitude?: number,
    onResponse?: (status: boolean) => void,
    options?: { silent?: boolean },
  ) => {
    const isSilent = options?.silent === true

    try {
      if (!isSilent) {
        enableLoad()
      }

      const payload = {
        eCourierStatusType: courierStatusType,
        lastLatitude: latitude ?? null,
        lastLongitude: longitude ?? null,
      }

      var response = await PostRequest<boolean>(API_ROUTES.DELIVERY.PUT_COURIER_STATUS, payload, ERequestType.Courier)

      if (response.success) {
        onResponse && onResponse(response.data)

        return
      }

      onResponse && onResponse(false)
      throw new Error(response.message)
    } catch (e: any) {
      if (!isSilent) {
        const message = e instanceof Error ? e.message : t("label_unknown_error_description")
        setError(t("label_title_erro"), message)
      }
    } finally {
      if (!isSilent) {
        disableLoad()
      }
    }
  }

  return {
    handleUpdateStatusAsync,
    handleTryCourierLinkAsync,
    handleTryUnlinkCourierLinkAsync,
    handleTryCourierCreateAccountAsync,
  }
}
